import { render } from "./DocumentUploadDragAndDrop.vue?vue&type=template&id=3dd5d376&scoped=true&ts=true"
import script from "./DocumentUploadDragAndDrop.vue?vue&type=script&lang=ts"
export * from "./DocumentUploadDragAndDrop.vue?vue&type=script&lang=ts"

import "./DocumentUploadDragAndDrop.vue?vue&type=style&index=0&id=3dd5d376&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd5d376"]])

export default __exports__